import { RuleTargetType } from 'services/api/entities/Rules'
import { ProductServiceDiscriminator } from 'types/common'

export const thenClauseTargettableServices: Record<
  RuleTargetType,
  ProductServiceDiscriminator[]
> = {
  package: ['DrinkConfigurator'],
  product: [
    'DrinkConfigurator',
    'ProfessionalConfigurator',
    'RentConfigurator',
  ],
}

export const serviceWhereAvailable: ProductServiceDiscriminator[] = [
  'FoodConfigurator',
]
